"use client";
import * as React from "react";
const SvgCallSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m16 11.08-4.68-.55-2.24 2.24a13.4 13.4 0 0 1-5.86-5.85l2.25-2.25L4.92 0H.02A15.1 15.1 0 0 0 16 15.98z" }));
export {
  SvgCallSharp as default
};
